module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    staticStyle: {
      "background-color": "rgba(250, 250, 250, 1)"
    }
  }, [_c('div', {
    staticClass: "page-progress flex-col"
  }, [_c('div', {
    staticClass: "flex-col justify-between"
  }, [_c('div', {
    staticClass: "mod4 flex-col"
  }, [_c('div', {
    staticClass: "bd1 flex-col"
  }, [_c('experiment-header', {
    attrs: {
      "contractNo": _vm.contractProgressInfo.contractNo,
      "status": _vm.contractProgressInfo.status
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, _vm._l((_vm.contractProgressInfo.progressNotes), function(progress, index) {
    return _c('div', {
      key: index,
      staticClass: "historyProgress"
    }, [_c('div', {
      staticClass: "box4 flex-row justify-between"
    }, [(index === 0) ? _c('img', {
      staticClass: "label1",
      attrs: {
        "referrerpolicy": "no-referrer",
        "src": "/static/img/最新进展.svg"
      }
    }) : _c('div', {
      staticClass: "bd3 flex-col"
    }), _vm._v(" "), (index === 0) ? _c('span', {
      staticClass: "info4"
    }, [_vm._v(_vm._s(progress.createDT) + " 最新进展：")]) : _c('span', {
      staticClass: "txt4"
    }, [_vm._v(_vm._s(progress.createDT))]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "main1 flex-col",
      staticStyle: {
        "margin-left": "13px"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [(index !== _vm.contractProgressInfo.progressNotes.length - 1) ? _c('div', {
      staticClass: "group_history flex-col"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "paragraph1",
      class: {
        'paragraph-font1': index !== 0,
          'paragraph-font2': index === 0,
      },
      style: ({
        'margin-left': index === _vm.contractProgressInfo.progressNotes.length - 1 ? '20px' : '10px',
      })
    }, [_c('span', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_vm._v("\n                    1.  " + _vm._s(progress.content) + "\n                    "), _c('br')])])])])
  }), 0)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a33df7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/serviceProgressRefactor/historyProgressDetail/index.vue
// module id = 1700
// module chunks = 8